import { render } from "./B2bPageDocumentacionDocumento.vue?vue&type=template&id=3e82efdf&scoped=true&lang=pug"
import script from "./B2bPageDocumentacionDocumento.vue?vue&type=script&lang=js"
export * from "./B2bPageDocumentacionDocumento.vue?vue&type=script&lang=js"

import "./B2bPageDocumentacionDocumento.vue?vue&type=style&index=0&id=3e82efdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e82efdf"]])

export default __exports__